import data from "../../../../../src/Autocomplete/Autocomplete.docs.json";
import { Autocomplete } from '@primer/react';
import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  data,
  Autocomplete,
  DeprecationBanner,
  React
};